"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reload = reload;
function reload() {
    window.location.reload();
}
//# sourceMappingURL=index.js.map